// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill'
import 'vant/lib/index.css'

import Vue from 'vue'
import Vant from 'vant'
import vueSeamlessScroll from 'vue-seamless-scroll'
import ElementUI from 'element-ui'

import App from './App'
import router from './router'

import { NavBar } from 'vant'
import { Lazyload } from 'vant'
import { Divider } from 'vant'
import { Field } from 'vant'
import { ActionSheet } from 'vant'
import { Form } from 'vant'
import { AddressList } from 'vant'
import { Dialog } from 'vant'
import { Toast } from 'vant'

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole);

// 全局注册
Vue.use(Dialog)

Vue.use(AddressList)
Vue.use(Toast)
Vue.use(ActionSheet)

Vue.use(vueSeamlessScroll)
Vue.use(ElementUI)
Vue.use(Form)
Vue.use(Divider)
Vue.use(Lazyload)
Vue.use(Field)
Vue.use(Vant)
Vue.use(NavBar)

localStorage.clear()
let tempStr = window.location.href
let tempArr = tempStr.split('?')[1] ? tempStr.split('?')[1].split('&') : []
let returnArr = {}
var that = this
tempArr.forEach((element) => {
  returnArr[element.split('=')[0]] = element.split('=')[1]
})
let openid=''
if (
  returnArr.openid != undefined &&
  returnArr.openid != null &&
  returnArr.openid != ''
) {
  openid = returnArr.openid
  localStorage.setItem('openid', openid)
}


// localStorage.setItem('tel', '15860832301')

ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js